var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJudging = function SvgJudging(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 17 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5c0 .459.375.834.833.834H17.5a.836.836 0 0 0 .833-.834.836.836 0 0 0-.833-.833h-1.667A.836.836 0 0 0 15 10.5zM13.825 14.517a.805.805 0 0 0 .167 1.141c.441.325.908.675 1.35 1.009.366.275.883.2 1.15-.167 0-.008.008-.008.008-.017a.815.815 0 0 0-.167-1.15c-.441-.333-.908-.683-1.341-1.008a.827.827 0 0 0-1.159.175c0 .008-.008.017-.008.017zM16.508 4.508c0-.008-.008-.008-.008-.016a.817.817 0 0 0-1.15-.167c-.442.333-.917.683-1.35 1.017a.816.816 0 0 0-.158 1.15c0 .008.008.008.008.016a.816.816 0 0 0 1.15.167c.442-.325.908-.683 1.35-1.017a.828.828 0 0 0 .158-1.15zM6.667 8H3.333c-.916 0-1.666.75-1.666 1.667v1.666c0 .917.75 1.667 1.666 1.667h.834v2.5c0 .458.375.833.833.833a.836.836 0 0 0 .833-.833V13h.834l4.166 2.5v-10L6.667 8zM12.917 10.5a3.734 3.734 0 0 0-1.25-2.792v5.575a3.702 3.702 0 0 0 1.25-2.783z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJudging, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/judging.ba707882.svg";
export { ForwardRef as ReactComponent };